/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate your body fat percentage using the US Navy method — just a tape measure. Measure your neck and waist (and hips for women) at the levels described and enter them below.`)
};

const es_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estima tu porcentaje de grasa corporal con el método de la Marina de EE. UU. — solo necesitas una cinta métrica. Mide tu cuello y cintura (y caderas si eres mujer) en los niveles indicados e introdúcelos abajo.`)
};

const de_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schätze deinen Körperfettanteil mit der US-Navy-Methode — nur ein Maßband nötig. Miss Hals und Taille (bei Frauen zusätzlich die Hüfte) an den beschriebenen Stellen und gib die Werte unten ein.`)
};

const nl_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schat je lichaamsvetpercentage met de US Navy-methode — alleen een meetlint nodig. Meet je nek en taille (en heupen bij vrouwen) op de beschreven plekken en vul ze hieronder in.`)
};

const fr_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimez votre pourcentage de masse grasse avec la méthode de la marine américaine — juste un mètre ruban. Mesurez votre cou et votre taille (et vos hanches pour les femmes) aux niveaux décrits et saisissez-les ci-dessous.`)
};

const it_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima la tua percentuale di grasso corporeo con il metodo della Marina statunitense — basta un metro da sarta. Misura collo e vita (e fianchi per le donne) ai livelli indicati e inseriscili qui sotto.`)
};

const pt_br2_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime seu percentual de gordura corporal usando o método da Marinha dos EUA — só com uma fita métrica. Meça o pescoço e a cintura (e o quadril, no caso das mulheres) nos pontos descritos e informe abaixo.`)
};

const pt_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estime a sua percentagem de gordura corporal com o método da Marinha dos EUA — só precisa de uma fita métrica. Meça o pescoço e a cintura (e as ancas, no caso das mulheres) nos pontos descritos e introduza os valores abaixo.`)
};

const ja_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`米海軍式の方法で体脂肪率を推定します — メジャー(巻き尺)だけで測定できます。指定された位置で首と腰(女性は腰囲も)を測り、以下に入力してください。`)
};

const zh_bf_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用美国海军法估算你的体脂率——只需一把皮尺。按说明测量颈部和腰部（女性还需测量臀部），然后在下方输入数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bf_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bf_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bf_intro", locale)
	if (locale === "en") return en_bf_intro(inputs)
	if (locale === "es") return es_bf_intro(inputs)
	if (locale === "de") return de_bf_intro(inputs)
	if (locale === "nl") return nl_bf_intro(inputs)
	if (locale === "fr") return fr_bf_intro(inputs)
	if (locale === "it") return it_bf_intro(inputs)
	if (locale === "pt-BR") return pt_br2_bf_intro(inputs)
	if (locale === "pt") return pt_bf_intro(inputs)
	if (locale === "ja") return ja_bf_intro(inputs)
	return zh_bf_intro(inputs)
};